import activateDraftRuleSetByFileNamesCommand from './activateDraftRuleSetByFileNamesCommand';
import addFileToDraft from './addFileToDraft';
import applyDraftCommand from './applyDraftCommand';
import {
  bulkActionRuleCommand,
  createEntityMinimalCommand,
  createOrUpdateRuleCommand,
  deleteDiagnosticTreeNodeConfigurationFromConsoleCommand,
  deleteDiagnosticTreeNodeResponseConfigurationFromConsoleCommand,
  deleteRuleCommand,
  generateEntityFromConsoleCommand,
  getEntityKeysBySellerQuery,
  getFileConfigurationDownloadQuery,
  getFilteredVersionsCommand,
  getRuleDefinitionQuery,
  getVersionsByFileQuery,
  getVersionsQuery,
  rollbackRuleFileToVersionCommand,
  upsertBpmnForDiagnosticTreeConfigurationFromConsoleCommand,
  UpsertEntityFromConsoleCommand,
} from './Console';
import deleteEntityFromConsoleCommand from './Console/deleteEntityFromConsoleCommand';
import duplicateRuleCommand from './Console/duplicateRuleCommand';
import getDebugInfoForConsoleCommand from './Console/getDebugInfoForConsoleCommand';
import getDependentRulesCommand from './Console/getDependentRulesCommand';
import getEntityBySellerQuery from './Console/getEntityBySellerQuery';
import { getEntityDefinitionQuery } from './Console/getEntityDefinitionQuery';
import { getFilteredEntityDefintionBySellerCommand } from './Console/getFilteredEntityDefintionBySellerCommand';
import { getMatchingRulesInfoCommand } from './Console/getMatchingRulesInfoCommand';
import getPredefinedFiltersQuery from './Console/getPredefinedFiltersQuery';
import createDraftCommand from './createDraftCommand';
import deleteDraftCommand from './deleteDraftCommand';
import { getCatalogTemplateQuery } from './Download/getCatalogTemplateQuery';
import { getLatestVersionDownloadableQuery } from './Download/getLatestVersionDownloadableQuery';
import getActiveDraftQuery from './getActiveDraftQuery';
import getDraftByIdQuery from './getDraftByIdQuery';
import getDraftByStatusesQuery from './getDraftByStatusesQuery';
import getDraftDocument from './getDraftDocument';
import { getImportReport } from './getImportReport';
import getImportReportByType from './getImportReportByType';
import getOnboardingWarrantiesQuery from './getOnboardingWarrantiesQuery';
import importDraft from './importDraft';
import importReport from './importReport';
import { importStockInventorySheetCommand } from './importStockInventorySheetCommand';
import getSalesImportDetailsQuery from './Sellers/getSalesImportDetailsQuery';
import getSalesImportErrorsQuery from './Sellers/getSalesImportErrorsQuery';
import getSalesImportSummariesQuery from './Sellers/getSalesImportSummariesQuery';
import { importResourceCommand } from './Sellers/importResourceCommand';
import importSalesCommand from './Sellers/importSalesCommand';
import setOnboardingWarrantiesCommand from './setOnboardingWarrantiesCommand';
import getImportLevelConfigurationQuery from './Tenants/getImportLevelConfigurationQuery';
import { upsertImportLevelConfigurationCommand } from './Tenants/upsertImportLevelConfigurationCommand';
import { getAvailableImportTypesQuery } from './Upload/getAvailableImportTypesQuery';
import { uploadFileWithImportTypeCommand } from './Upload/uploadFileWithImportTypeCommand';

export const ImportService = {
  getDraftByStatusesQuery,
  getActiveDraftQuery,
  deleteDraftCommand,
  createDraftCommand,
  applyDraftCommand,
  addFileToDraft,
  getDraftDocument,
  getImportReportByType,
  importDraft,
  importReport,
  activateDraftRuleSetByFileNamesCommand,
  createOrUpdateRuleCommand,
  bulkActionRuleCommand,
  createEntityMinimalCommand,
  UpsertEntityFromConsoleCommand,

  getRuleDefinitionQuery,
  getEntityBySellerQuery,
  getEntityDefinitionQuery,
  getEntityKeysBySellerQuery,
  getFilteredEntityDefintionBySellerCommand,
  getVersionsQuery,
  getFilteredVersionsCommand,
  getVersionsByFileQuery,
  deleteRuleCommand,
  getMatchingRulesInfoCommand,
  getFileConfigurationDownloadQuery,
  getDraftByIdQuery,
  getImportReport,
  getPredefinedFiltersQuery,
  getSalesImportSummariesQuery,
  importSalesCommand,
  getSalesImportErrorsQuery,
  getSalesImportDetailsQuery,
  upsertBpmnForDiagnosticTreeConfigurationFromConsoleCommand,
  deleteDiagnosticTreeNodeConfigurationFromConsoleCommand,
  deleteDiagnosticTreeNodeResponseConfigurationFromConsoleCommand,
  rollbackRuleFileToVersionCommand,
  generateEntityFromConsoleCommand,
  getDebugInfoForConsoleCommand,
  duplicateRuleCommand,
  importResourceCommand,
  getDependentRulesCommand,
  deleteEntityFromConsoleCommand,
  setOnboardingWarrantiesCommand,
  getOnboardingWarrantiesQuery,

  getAvailableImportTypesQuery,
  uploadFileWithImportTypeCommand,
  getLatestVersionDownloadableQuery,

  getImportLevelConfigurationQuery,
  upsertImportLevelConfigurationCommand,
  getCatalogTemplateQuery,

  importStockInventorySheetCommand,
};
